import {Image, ImageProps} from '@chakra-ui/react';

import giftIcon from './gift-icon.png';

export const GiftIcon = (props: ImageProps) => <Image src={giftIcon.src} alt="" objectFit="contain" {...props} />;
